module.exports = __webpack_public_path__ + "img/loginChargerWarning.fa44e357.svg";